import { useQuery } from "@tanstack/react-query";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { get } from "common/helpers/HTTP";

async function getCustomerCreditsRequest(): Promise<number> {
  return (await get("customers/credits")).promotional_credits;
}

export default function useCustomerCredits() {
  const { data: customerCredits, isLoading: isLoadingCustomerCredits } =
    useQuery({
      queryKey: CUSTOMER_QUERY_KEYS.credits,
      queryFn: getCustomerCreditsRequest,
    });

  return { customerCredits, isLoadingCustomerCredits };
}
